import React from 'react';
import styled, { keyframes } from 'styled-components';

const badgePulse = keyframes`
  0%   { transform: scale(1); }
  50%  { transform: scale(1.07); }
  100% { transform: scale(1); }
`;

/* 
  Animação de ripple (onda) contínua.
  Move a sombra para baixo e direita, expandindo o spread e sumindo.
*/
const rippleOut = keyframes`
  0% {
    box-shadow: 2px 4px 0 0px rgba(6, 67, 237, 0.7);
  }
  70% {
    box-shadow: 12px 18px 0 8px rgba(6, 67, 237, 0);
  }
  100% {
    box-shadow: 12px 18px 0 8px rgba(6, 67, 237, 0);
  }
`;

const ButtonWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 20px;
  margin-top: 15px;
`;

const StyledButton = styled.button`
  position: relative;
  background: linear-gradient(90deg, #1b7dff 0%, #0643ed 100%);
  color: white;
  border: none;
  border-radius: 14px; /* Menos arredondado, como um retângulo com cantos curvos */
  padding: 12px 28px;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.15s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.15s ease;
  box-shadow: 0px 6px 0px #032b9c;
  z-index: 1;

  &::before, &::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    border-radius: inherit;
    z-index: -1;
    animation: ${rippleOut} 4.6s infinite ease-out;
    pointer-events: none;
  }
  
  &::after {
    animation-delay: 2.3s;
  }

  &:hover {
    background: linear-gradient(90deg, #2884ff 0%, #0a49f5 100%);
    box-shadow: 0px 6px 0px #032b9c;
  }
  
  &:hover::before, &:hover::after {
    animation: none;
    box-shadow: 4px 6px 0 2px rgba(6, 67, 237, 0.5);
  }

  &:active {
    transform: translateY(4px);
    box-shadow: 0px 2px 0px #032b9c;
  }
  
  &:active::before, &:active::after {
    box-shadow: none;
  }
`;

/*
  Ícone fiel ao PNG: estrela grande (✦) + estrela pequena (✦) no canto superior-direito.
  viewBox maior para dar espaço. Tamanho 30x30.
*/
const SparkleIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0, marginTop: '1px' }}
  >
    {/* Estrela grande — centro em (14, 20) */}
    <path
      d="M14 6 L16.5 14 L24 16.5 L16.5 19 L14 27 L11.5 19 L4 16.5 L11.5 14 Z"
      fill="white"
    />
    {/* Estrela pequena — canto superior-direito, centro em (26, 10) */}
    <path
      d="M26 4 L27.4 8.6 L32 10 L27.4 11.4 L26 16 L24.6 11.4 L20 10 L24.6 8.6 Z"
      fill="white"
    />
  </svg>
);

const Badge = styled.span`
  position: absolute;
  top: -16px;
  right: 12px;
  background-color: #ff00a0;
  color: white;
  font-size: 13px;
  font-weight: 800;
  padding: 4px 14px;
  border-radius: 10px;
  animation: ${badgePulse} 2.5s infinite;
  box-shadow: 0 3px 8px rgba(255, 0, 160, 0.45);
  z-index: 10;
  letter-spacing: 0.3px;
`;

export default function AIEmitButton({ onClick }) {
  return (
    <ButtonWrapper>
      <Badge>Novo</Badge>
      <StyledButton onClick={onClick} type="button">
        <SparkleIcon /> Preencher nota com IA
      </StyledButton>
    </ButtonWrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/AIEmitButton/index.jsx